import type {AuditInfo} from "../common/audit-info";

export enum HolidayType {
    NATIONAL_HOLIDAY = "NATIONAL HOLIDAY",
    RESTRICTED = "RESTRICTED",
    OPTIONAL = "OPTIONAL",
    MANDATORY = "MANDATORY",
    EMERGENCY = "EMERGENCY",
}

export enum DayOfWeek {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY",
}

export interface Holiday {
    id?: string;
    year: string;
    name: string;
    type: HolidayType;
    date: Date;
    day: DayOfWeek;
    notify?: boolean;
    auditInfo?: AuditInfo;
}
